export default __webpack_public_path__ + "static/media/Ballroll_00202.7588e411.png";